define('LimitItemQuantity.Helper', [
  'LiveOrder.Model',
  'Configuration',
  'Utils',
  'jQuery',
  'underscore'
], function LimitItemQuantityHelper(
  LiveOrderModel,
  Configuration,
  Utils,
  jQuery,
  _
) {
  'use strict';

  var DISALLOW_BACKORDER_W_DEFAULT_MESSAGE = 'Disallow Backorder w/ Default Message';

  return {
    insufficientAmount: {
      errorCode: 'ERR_EXT_CANCELED_OPERATION',
      errorMessage: Utils.translate('You can only purchase a maximum of [QTY] of this item.')
    },

    insufficientAmountPlaceOrder: {
      errorCode: 'ERR_INSUFFICIENT_AMOUNT_PLACE_ORDER',
      errorMessage: Utils.translate('The following items are not eligible for backorder: [ITEMS]')
    },

    findItemInCart: function findItemInCart(selectedLine) {
      var liveOrder = LiveOrderModel.getInstance();
      return _.find(liveOrder.get('lines').models, function findLines(line) {
        return line.get('item').get('internalid') === selectedLine.get('internalid');
      });
    },

    _isBackorderable: function _isBackorderable(item) {
      var customOutOfStockConfig = Configuration.get('CustomStockBehavior') || {};
      var customBehavior = customOutOfStockConfig && customOutOfStockConfig.outOfStockBehavior;
      if (customBehavior) {
        return customBehavior !== DISALLOW_BACKORDER_W_DEFAULT_MESSAGE;
      }
      return item.isbackorderable;
    },

    validateItem: function validateItem(item, qty, cartLines, pdpComponent) {
      var isValid = true;
      var addToCartQty = qty;
      var itemFound;
      var itemId = item.internalid;
      var quantityAvailable = item.quantityavailable;
      var selectedMatrix;
      if (cartLines) {
        selectedMatrix = pdpComponent.getSelectedMatrixChilds();
        if (selectedMatrix.length === 1) {
          itemId = selectedMatrix[0].internalid;
          quantityAvailable = selectedMatrix[0].quantityavailable;
        }
        itemFound = _.find(cartLines, function findLine(line) {
          return line.item.internalid === itemId;
        });
        addToCartQty = itemFound ? itemFound.quantity + addToCartQty : addToCartQty;
      }
      if (!this._isBackorderable(item) && quantityAvailable < addToCartQty) {
        isValid = false;
      }
      return {
        isValid: isValid,
        quantityAvailable: quantityAvailable
      };
    },

    errorResponse: function errorResponse(error) {
      return jQuery.Deferred().reject({
        'responseJSON': this.insufficientAmount,
        'responseText': JSON.stringify({
          'errorMessage': error
        })
      });
    }
  };
});
